import { useLocation } from "react-router"

const useReviewContext = () => {
    const location = useLocation();
    return /^\/review/.test(location.pathname);
}
export default useReviewContext;